export default __webpack_public_path__ + "static/media/team-1.0fd36e0e.jpg";